import {Alert, Button, Card, CardBody, CardHeader, Typography,} from "@material-tailwind/react";
import {useEffect, useState} from "react";
import {AgentRequestSteps} from "./steps";
import {AgentRequestPersonalInfo} from "./agent_request_personal_info"
import {getUserAgentRequest} from "../../../services/agent/agent_request"
import {BsHourglassSplit} from "react-icons/bs";
import Dict from "../../../helper/dict";
import {roleSwitch} from "../../../services/user/login";
import authManager from "../../../helper/AuthHelper";
import {AgentRequestContext} from "../../../context/agent_context";
import {AgentRequestContactInfo} from "./agent_request_contact_info";
import {AgentRequestExpertInfo} from "./agent_request_expert_info";
import {AgentRequestFile} from "./agent_request_file";
import {BriefcaseIcon} from "@heroicons/react/24/outline";

export function AgentRequestManagement({changeComponent}) {

  const [activeStep, setActiveStep] = useState(null);
  const [agentRequest, setAgentRequest] = useState();

  const [isLastStep, setIsLastStep] = useState(false);
  const [isFirstStep, setIsFirstStep] = useState(false);
  const [allowedStep, setAllowedStep] = useState(null);

  const [agentLog, setAgentLog] = useState("no_one");

  const handleNext = (step) => (setActiveStep(step))
  const handlePrev = (step) => (setActiveStep(step))

  useEffect(() => {
    async function getData() {
      const result = await getUserAgentRequest();
      if (result.status === 200) {
        const {agent_request, agent_log} = result.data;
        setAgentRequest(agent_request);
        setActiveStep(agent_request?.step ?? 0);
        setAllowedStep(agent_request?.step ?? 0);
        setAgentLog(agent_log)
      } else {
        setAgentRequest(null);
        setActiveStep(0);
        setAllowedStep(0);
      }
    }

    getData()
  }, []);

  useEffect(() => {
    setAgentLog(agentLog)
  }, [agentLog]);

  useEffect(() => {
    if (!(agentRequest?.id)) {
      setAllowedStep(0)
    } else {
      setAllowedStep(agentRequest.step)
    }
  }, [agentRequest])

  useEffect(() => {
    if (allowedStep <= activeStep) {
      setAllowedStep(activeStep)
    }
  }, [activeStep]);

  async function changeRole() {
    const data = {
      role_id: 2,
    };
    let result;

    result = await roleSwitch(data);

    if (result.status === 200) {
      authManager.loginHandler(result.data)
      window.location.href = '/';
      localStorage.setItem("lastClicked", "agent_request")
    }
  }

  const messages = {
    'new': {
      'text': 'کاربر گرامی، درخواست شما جهت بررسی و تائید اطلاعات اولیه به پلتفرم مباشر ارسال شد.',
      'icon': <BsHourglassSplit className="flex ml-2 text-xl"/>
    },
    'accepted': {
      'text': 'درخواست شما پذیرفته شد',
      'icon': <BsHourglassSplit className="flex ml-2 text-xl"/>
    },
    'rejected': {
      'text': 'درخواست شما رد شد',
      'icon': <BsHourglassSplit className="flex ml-2 text-xl"/>
    },
  }

  const stepContent = [
    {title: "اطلاعات هویتی", description: "مشخصات فردی خود را مطابق مدارک شناسایی وارد کنید."},
    {title: "اطلاعات ارتباطی", description: "راه‌های ارتباطی و نشانی محل سکونت خود را تکمیل کنید."},
    {title: "سوابق و تخصص", description: "تحصیلات، تجربه و حوزه‌های مورد نظر برای همکاری را مشخص کنید."},
    {title: "مدارک مورد نیاز", description: "مدارک را بارگذاری و درخواست خود را برای بررسی ارسال کنید."},
  ];

  const currentStepContent = stepContent[activeStep] ?? stepContent[0];

  return (
    <AgentRequestContext.Provider value={{
      agentRequest,
      setAgentRequest,
      agentLog,
      setAgentLog,
      activeStep,
      setActiveStep,
      isLastStep,
      setIsLastStep,
      isFirstStep,
      setIsFirstStep,
      allowedStep,
      setAllowedStep,
      handleNext,
      handlePrev,
    }}>
      <div className="mx-auto w-full max-w-6xl py-2 sm:py-4">
        <Card className="h-full overflow-hidden rounded-3xl border border-app-border bg-app-surface shadow-app">
          <CardHeader floated={false} shadow={false} className="m-0 rounded-none bg-app-primary px-5 py-4 text-app-on-primary sm:px-7">
            <div className="flex items-center gap-4">
              <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-white/10">
                <BriefcaseIcon className="h-5 w-5"/>
              </div>
              <div>
                <Typography variant="h5" className="font-bold text-app-on-primary">همکاری با ما</Typography>
                <Typography className="mt-1 text-sm text-app-on-primary/70">
                  برای پیوستن به جمع مشاوران مباشر، اطلاعات زیر را تکمیل کنید.
                </Typography>
              </div>
            </div>
            {
              agentLog && agentLog.status &&
              <>
                <Alert className="mt-4 flex flex-row rounded-xl border border-white/15 bg-white/10 py-3 text-app-on-primary">
                  <Typography className="flex font-semibold">
                    {messages[agentLog.status]['icon']}
                    {messages[agentLog.status]['text']}
                  </Typography>
                  {agentLog.status === 'accepted' &&
                    <div className="flex flex-col gap-y-2 mt-4 mb-4">
                      <Typography variant="h5" className="">
                        به منظور شروع فعالیت در پلتفرم مباشر، اقدامات زیر را انجام دهید:
                      </Typography>
                      <Button variant="text" color="white" className="max-w-fit" onClick={() => {
                        changeRole();
                      }}>
                        - تغییر نقش به مباشر
                      </Button>
                      <Button variant="text" color="white" className="max-w-fit" onClick={() => {
                        localStorage.setItem("defaultItem", "agent_request");
                        changeComponent("agent_branch_fee")
                      }}>
                        - تعریف تعرفه خدمات، در قسمت آیتم های همکاری
                      </Button>
                      <Button variant="text" color="white" className="max-w-fit" onClick={() => {
                        localStorage.setItem("defaultItem", "agent_request");
                        changeComponent("schedule")
                      }}>
                        - تعریف برنامه زمان بندی، در قسمت مشاوره
                      </Button>
                      <Button variant="text" color="white" className="max-w-fit" onClick={() => {
                        localStorage.setItem("defaultItem", "agent_request");
                        changeComponent("agent_branch_document")
                      }}>
                        - تعریف مدارک مورد نیاز هر گرایش، در قسمت خدمات من
                      </Button>
                    </div>
                  }
                  {agentLog && agentLog.comment &&
                    <div className="flex flex-row mb-4">
                      <Typography variant="h5" className="ml-4">
                        {`${Dict('description')} ادمین: `}
                      </Typography>
                      <Typography>
                        {agentLog.comment}
                      </Typography>
                    </div>
                  }
                </Alert>


              </>
            }


          </CardHeader>
          <CardBody className="h-full w-full overflow-visible p-4 sm:p-5">
            <div className="rounded-2xl border border-app-border bg-app-muted/40 px-3 py-4 sm:px-5">
              <AgentRequestSteps/>
            </div>
            <div className="mt-4 rounded-2xl border border-app-border bg-app-raised p-4 sm:p-5">
              <div className="mb-5 border-b border-app-border pb-3">
                <Typography variant="h5" className="font-bold text-app-text">
                  {currentStepContent.title}
                </Typography>
                <Typography className="mt-2 text-sm leading-6 text-app-text-muted">
                  {currentStepContent.description}
                </Typography>
              </div>

              <div className="agent-request-form">
                {activeStep === 0 && <AgentRequestPersonalInfo/>}
                {activeStep === 1 && <AgentRequestContactInfo/>}
                {activeStep === 2 && <AgentRequestExpertInfo/>}
                {activeStep === 3 && <AgentRequestFile/>}
              </div>
            </div>

          </CardBody>
        </Card>
      </div>
    </AgentRequestContext.Provider>
  );
}
